var imagesBundle = [],
  imagesBundleVal = [];

function updatePricing() {
  var currencySymbol = $(".product-builder-wrapper").data("currency-symbol");
  var currencyIso = $(".product-builder-wrapper").data("currency-iso");

  // Initialize all pricing elements to 0 and set default prices
  $(".letters_pricing").each(function () {
    let defaultPrice = $(this).data("single-price");
    $(this).find(".nmbs").html("0");
    $(this)
      .find(".prcing")
      .html(currencySymbol + defaultPrice);
  });

  // Gather all unique pkey values from imagesBundle
  let uniquePkeys = [...new Set(imagesBundle.map((v) => v.pkey))];

  // Update each pricing section dynamically
  uniquePkeys.forEach((pkey) => {
    let lengthArray = imagesBundle.filter((v) => v.pkey === pkey);

    let pricingElement = $(`.letters_pricing[data-letter-title='${pkey}']`);
    let singlePrice =
      parseFloat(
        String(pricingElement.data("single-price")).replace(",", "")
      ) || 0;

    pricingElement.find(".nmbs").html(lengthArray.length);
    pricingElement
      .find(".prcing")
      .html(currencySymbol + singlePrice.toLocaleString());
  });

  // Calculate the total price
  let baseProductPrice = parseFloat(
      $(".builder_base_price").val().replace(",", "")
    ),
    lettersPrice = imagesBundle.reduce(
      (acc, v) =>
        acc +
        parseFloat(
          String(v.price)
            .replace(/[^\d.-]/g, "")
            .replace(",", ".")
        ),
      0
    ),
    totalBuilderPrice = baseProductPrice + lettersPrice;

  // Format the total price for JPY
  if (currencyIso === "JPY") {
    totalBuilderPrice = Math.round(totalBuilderPrice).toLocaleString("en-US", {
      maximumFractionDigits: 0,
    });
  } else {
    totalBuilderPrice = totalBuilderPrice.toFixed(2);
  }

  $(".tprice").html(currencySymbol + totalBuilderPrice + " " + currencyIso);

  // Show or hide .letters_pricing elements based on .nmbs value
  updateLettersPricingVisibility();
}

function updateLettersPricingVisibility() {
  $(".letters_pricing").each(function () {
    let nmbsValue = $(this).find(".nmbs").html();
    if (parseInt(nmbsValue) > 0) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
}

function updateChainPoints() {
  var productCount = imagesBundle.length;
  var layout = productCount % 2 === 0 ? "even" : "odd";
  var startPosition;

  if (layout === "odd") {
    startPosition = 6 - Math.floor(productCount / 2);
  } else {
    startPosition = 6 - Math.floor((productCount - 1) / 2);
  }

  $(".builderChainPoint").hide().html("");

  $.each(imagesBundle, function (index) {
    var point = startPosition + index,
      variantImage = imagesBundle[index].image,
      typeoitem = imagesBundle[index].typeoitem,
      id = imagesBundle[index].id;

    $(
      ".builderChainPoint[data-point='" +
        point +
        "'][data-style='" +
        layout +
        "']"
    )
      .attr("typeoitem", typeoitem)
      .show()
      .html(
        '<img src="' +
          variantImage +
          '" /><button class="remove_selected_from_builder" dataindex="' +
          index +
          '" dataid="' +
          id +
          '"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><rect x="0.890625" y="0.589844" width="19" height="19" rx="9.5" fill="white" stroke="#252525"/><path d="M7.25391 6.94727L13.5393 13.2327" stroke="#252525"/><path d="M13.543 6.94531L7.25757 13.2307" stroke="#252525"/></svg></button>'
      );
  });
}

// Call updateChainPoints whenever the chain points need to be updated
updateChainPoints();

// Function to update the button state
function updateButtonState() {
  $(".product-form__submit_builder")
    .prop("disabled", imagesBundle.length === 0)
    .find("span")
    .html(imagesBundle.length ? "ADD TO BASKET" : "Select Letters");
}

$(document).ready(function () {
  $("input[name='chains']").change(function () {
    let selectedFullPrice = $(this).data("chain-full-price");
    let selectedVariantId = $(this).val();

    // Update builder base price
    let selectedPrice = $(this).data("chain-variant-price");
    $(".builder_base_price").val(selectedPrice);

    // Update chain price display
    $("#chain_price").html(selectedFullPrice);

    // Update current product value
    $(".current_product_value").val(selectedVariantId);

    // Show/hide chain images based on selection
    if ($("#gold_chain_option input").is(":checked")) {
      $("#gold_chain_image").show();
      $("#silver_chain_image").hide();
    } else if ($("#silver_chain_option input").is(":checked")) {
      $("#gold_chain_image").hide();
      $("#silver_chain_image").show();
    }

    // Call updatePricing to recalculate the total price
    updatePricing();
  });

  // Initial check on page load
  if ($("#gold_chain_option input").is(":checked")) {
    $("#gold_chain_image").show();
    $("#silver_chain_image").hide();
  } else if ($("#silver_chain_option input").is(":checked")) {
    $("#gold_chain_image").hide();
    $("#silver_chain_image").show();
  }
});

$(document).ready(function () {
  // Get the max items limit
  var maxItems = parseInt($(".product-builder-wrapper").attr("max-items"));

  updateButtonState();

  // Set the first li HTML to .current_builder_active_tabs on page load
  var firstTabHtml = $("ul.builder_tabs li:first-child span").html();
  $(".current_builder_active_tabs").html(firstTabHtml);

  // Tab click handlers
  $("ul.builder_tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");
    $("ul.builder_tabs li, .builder_tabstabcontent").removeClass("current");
    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
    var sp = $(this).find("span").html();
    $(".current_builder_active_tabs").html(sp);
  });

  // Set initial text on page load
  var initialInstruction1 = $(".builderChainContent .fst").data(
    "instruction-1"
  );
  var initialInstruction2 = $(".builderChainContent .coloured_text").data(
    "instruction-2"
  );

  $(".builderChainContent .fst").html(initialInstruction1);
  $(".builderChainContent .coloured_text").html(initialInstruction2);

  // Alphabetical icon click handler
  $(document).on("click", "li.alphabetical_icon", function () {
    if (!$(this).hasClass("vnot_available")) {
      var im = $(this).children("img").attr("src"),
        id = $(this).attr("dataid"),
        price = $(this).attr("dataprice"),
        typeoitemin = $(this).find("img").attr("type_of_necklace"),
        dataproducttitle = $(this).attr("dataproducttitle"),
        ttitle = $(this).attr("datatitle");

      imagesBundle.push({
        image: im,
        id,
        price,
        title: ttitle,
        pkey: dataproducttitle,
        typeoitem: typeoitemin,
      });
      imagesBundleVal.push({ quantity: 1, id });
      var productCount = imagesBundle.length - 1;

      // Update button and error message
      if (imagesBundle.length > maxItems) {
        $(".errormessage_builder").html(
          "<p>Maximum " + maxItems + "  letters allowed</p>"
        );
        $(".builderChainContent p.fst").html(
          "YOU HAVE REACHED THE MAXIMUM OF " + maxItems + "  CHARACTERS"
        );
        setTimeout(function () {
          $(".errormessage_builder").html("");
        }, 2500);
        imagesBundle.pop();
        imagesBundleVal.pop();
        return;
      }

      $(".builderChainContent p.fst").html(initialInstruction1);
      if (imagesBundle.length === maxItems) {
        $(".builderChainContent p.fst").html(
          "YOU HAVE REACHED THE MAXIMUM OF " + maxItems + "  CHARACTERS"
        );
      } else {
        $(".builderChainContent p.fst").html(initialInstruction1);
      }

      // Update chain points
      var startPosition = Math.floor(6 - productCount / 2 + 1),
        layout = imagesBundle.length % 2 === 0 ? "even" : "odd";
      $(".necklacebuilder_value").val(JSON.stringify(imagesBundleVal));
      $(".necklacebuilder_value_properties").val(JSON.stringify(imagesBundle));
      $(".builderChainPoint").hide().html("");

      $.each(imagesBundle, function (index) {
        var point = startPosition + index,
          variantImage = imagesBundle[index].image,
          typeoitem = imagesBundle[index].typeoitem,
          id = imagesBundle[index].id;

        $(
          ".builderChainPoint[data-point='" +
            point +
            "'][data-style='" +
            layout +
            "']"
        )
          .attr("typeoitem", typeoitem)
          .html(
            '<img src="' +
              variantImage +
              '" /><button class="remove_selected_from_builder" dataindex="' +
              index +
              '" dataid="' +
              id +
              '"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><rect x="0.890625" y="0.589844" width="19" height="19" rx="9.5" fill="white" stroke="#252525"/><path d="M7.25391 6.94727L13.5393 13.2327" stroke="#252525"/><path d="M13.543 6.94531L7.25757 13.2307" stroke="#252525"/></svg></button>'
          );
      });

      updateButtonState();
      updateChainPoints();
      updatePricing();

      // Update selected products display
      var selected_products = "<ul>";
      $.each(imagesBundle, function (index) {
        var variantImage = imagesBundle[index].image,
          id = imagesBundle[index].id;
        selected_products +=
          '<li><img src="' +
          variantImage +
          '"><button class="remove_selected_from_builder" dataindex="' +
          index +
          '" dataid="' +
          id +
          '">Remove</button></li>';
      });
      selected_products += "</ul>";
      $(".selected_letters_and_pro")
        .toggleClass("active", imagesBundle.length > 0)
        .html(selected_products);
    }
  });

  // Remove selected item handler
  $(document).on("click", ".remove_selected_from_builder", function () {
    var eindex = $(this).attr("dataindex");
    imagesBundle.splice(eindex, 1);
    imagesBundleVal.splice(eindex, 1);

    updateButtonState();

    var productCount = imagesBundle.length - 1,
      startPosition = Math.floor(6 - productCount / 2 + 1),
      layout = imagesBundle.length % 2 === 0 ? "even" : "odd";

    $(".necklacebuilder_value").val(JSON.stringify(imagesBundleVal));
    $(".necklacebuilder_value_properties").val(JSON.stringify(imagesBundle));
    $(".builderChainPoint").hide().html("");
    $(".builderChainContent p.fst").html("CLICK ON THE LETTERS");

    $.each(imagesBundle, function (index) {
      var point = startPosition + index,
        variantImage = imagesBundle[index].image,
        typeoitem = imagesBundle[index].typeoitem,
        id = imagesBundle[index].id;

      $(
        ".builderChainPoint[data-point='" +
          point +
          "'][data-style='" +
          layout +
          "']"
      )
        .attr("typeoitem", typeoitem)
        .html(
          '<img src="' +
            variantImage +
            '" /><button class="remove_selected_from_builder" dataindex="' +
            index +
            '" dataid="' +
            id +
            '"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><rect x="0.890625" y="0.589844" width="19" height="19" rx="9.5" fill="white" stroke="#252525"/><path d="M7.25391 6.94727L13.5393 13.2327" stroke="#252525"/><path d="M13.543 6.94531L7.25757 13.2307" stroke="#252525"/></svg></button>'
        );
    });

    updateChainPoints(); // Add this line
    // Update pricing
    updatePricing();

    // Update selected products display
    var selected_products = "<ul>";
    $.each(imagesBundle, function (index) {
      var variantImage = imagesBundle[index].image,
        id = imagesBundle[index].id;
      selected_products +=
        '<li><img src="' +
        variantImage +
        '"><button class="remove_selected_from_builder" dataindex="' +
        index +
        '" dataid="' +
        id +
        '">Remove</button></li>';
    });
    selected_products += "</ul>";
    $(".selected_letters_and_pro")
      .toggleClass("active", imagesBundle.length > 0)
      .html(selected_products);

    // Hide the container if no items are left
    if (imagesBundle.length === 0) {
      $(".selected_letters_and_pro").removeClass("active");
    }
  });




  
  /** ADD PRODUCTS TO THE CART **/
  $(".product-form__submit_builder").click(function (e) {
    e.preventDefault();
    var itemsss = $(".necklacebuilder_value").val(),
      current_product_value = $(".current_product_value").val(),
      items_properties = $(".necklacebuilder_value_properties").val(),
      items_properties_json = JSON.parse(items_properties),
      titleArray = items_properties_json.map((el) => el.title),
      titleString = titleArray.toString(),
      items_f = itemsss ? JSON.parse(itemsss) : [];

    if (items_f.length === 0) return;

    $(".product-form__submit_builder span").hide();
    $(".loading-overlay__spinner").removeClass("hidden");

    var current_pro = {
      id: current_product_value,
      quantity: 1,
      properties: { letters_order: titleString },
    };
    items_f.push(current_pro);

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: { items: items_f },
      success: function () {
        $(".product-form__submit_builder span").show();
        $(".loading-overlay__spinner").addClass("hidden");

        // Fetch the updated cart data and update the cart view
        fetch("/?section_id=cart_js")
          .then((response) => response.text())
          .then((data) => {
             theme.eventBus.emit('cart:update');
             theme.eventBus.emit('cart:added');
            geckoShopify.onCartUpdate(1, 1, data);
            TriggerSidebarDropdow();
          })
          .catch((error) => console.error("Error updating cart:", error));
      },
      error: function (err) {
        console.log(err);
        $(".product-form__submit_builder span").show();
        $(".loading-overlay__spinner").addClass("hidden");
        if (err.responseJSON && err.responseJSON.description) {
          $(".product-form__submit_builder").after(
            '<p class="error">' + err.responseJSON.description + "</p>"
          );
          setTimeout(function () {
            $(".error").remove();
          }, 2500);
        }
      },
    });
    setTimeout(() => {
      document.querySelector(".cart-drawer").classList.add("is-active");
    }, 3500);
          
  });







  

  function TriggerSidebarDropdow() {
    if ($("body").hasClass("pside_opened")) return;
    // Show hidden sidebar/dropdown
    if (yes_hover && $("body").hasClass("cart_pos_dropdown")) {
      var $ic_cart = $(
        ".cart_pos_dropdown .ntheader:not(.h_scroll_down) .icon_cart"
      );
      $ic_cart.trigger("mouseenter");
    } else {
      $('.push_side[data-id="#nt_cart_canvas"]').trigger("click");
    }
  }
});
